import "./index.scss"
import React, { useRef, useEffect, useState } from "react"
import mapboxgl from "!mapbox-gl"
import "mapbox-gl/dist/mapbox-gl.css"
import AffiliateCard from "../Cards/AffiliateCard"
import closeX from "../Icons/affiliateClose.svg"
import { useStaticQuery, graphql } from "gatsby"
import MobileSVG from "./MobileSVG"

export default function NarrativeMapSection({ component }) {
  // = = = = = = = = = = =
  // Use States
  const [clickedPoint, setClickedPoint] = useState("")
  const [opened, setOpened] = useState(false)
  const [map, setMap] = useState(null)
  const mapContainerRef = useRef(null)

  // = = = = = = = = = = =
  // Map Section Data
  const { headline, intro } = component
  const MAPBOX_TOKEN =
    "pk.eyJ1IjoibWFyLXNwYWRhIiwiYSI6IjNka2J2VjgifQ.7wxvbiprk6i3s4D8HXSBpg"

  //  = = = = = = = = = =
  // Graphql
  const affiliatesData = useStaticQuery(graphql`
    query myQuery {
      affiliates: allDatoCmsAffiliate {
        nodes {
          intro
          websiteLink
          name
          locationText
          image {
            gatsbyImageData(placeholder: BLURRED)
          }
          location {
            latitude
            longitude
          }
        }
      }
    }
  `)

  //  = = = = = = = = = =
  //Event Handlers
  const clickPoint = clicked => {
    const filteredPost = points.filter(point => point.name === clicked)
    setClickedPoint(filteredPost[0])
    setOpened(true)
  }
  const handleClose = () => {
    setOpened(false)
    setClickedPoint("")
  }

  //  = = = = = = = = = =
  // Create JSON Data for Map
  const points = affiliatesData.affiliates.nodes
  const mapPoints = points.map(affiliate => {
    return {
      type: "Feature",
      properties: {
        name: affiliate.name,
      },
      geometry: {
        type: "Point",
        coordinates: [
          affiliate.location?.longitude,
          affiliate.location?.latitude,
        ],
      },
    }
  })

  const pointCollection = {
    type: "FeatureCollection",
    features: mapPoints,
  }

  //  = = = = = = = = = =
  // Map Init Styles
  const mapContainerStyle = {
    width: "100%",
    height: "400px",
  }

  //  = = = = = = = = = =
  // Map Init Hook
  useEffect(() => {
    const map = new mapboxgl.Map({
      container: mapContainerRef.current,
      accessToken: MAPBOX_TOKEN,
      style: "mapbox://styles/mar-spada/cl0kxm7om005k15o8sduo4l50",
      center: [-95.535, 37.451],
      zoom: 3,
    })
    map.boxZoom.disable()
    map.scrollZoom.disable()
    map.dragPan.disable()
    map.dragRotate.disable()
    map.keyboard.disable()
    map.doubleClickZoom.disable()
    map.touchZoomRotate.disable()
    map.on("load", () => {
      map.addSource("points", {
        type: "geojson",
        data: pointCollection,
      })
      map.addLayer({
        id: "points",
        type: "circle",
        source: "points",
        paint: {
          "circle-color": "#FD495C",
          "circle-radius": 8,
          "circle-stroke-width": 4,
          "circle-stroke-color": "#fff",
        },
        layout: {
          "circle-sort-key": 1,
        },
      })
      //Closure of onload function
    })

    // Helper Map Functions
    map.on("mouseenter", "points", () => {
      map.getCanvas().style.cursor = "pointer"
    })
    map.on("mouseleave", "points", () => {
      map.getCanvas().style.cursor = ""
    })

    //Click events here
    map.on("click", "points", e => {
      const clicked = e.features[0].properties.name
      clickPoint(clicked)
    })

    setMap(map)

    return () => map.remove()
  }, [])

  return (
    <section className="narrative-map-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-xl-5">
            <h2 className="oblique">{headline}</h2>
            <div
              className="reg"
              dangerouslySetInnerHTML={{ __html: intro }}
            ></div>
          </div>
          <div className="col-lg-7 mobile-map">
            <MobileSVG />
          </div>
          <div className="col-lg-8 col-xl-7 desktop-map">
            <img
              src={closeX}
              alt="close"
              className="closeX"
              onClick={() => handleClose()}
              style={{ display: opened ? "block" : "none" }}
            />
            <div ref={mapContainerRef} style={mapContainerStyle}></div>

            {clickedPoint ? (
              <AffiliateCard opened={opened} affiliatePost={clickedPoint} />
            ) : null}
          </div>
        </div>
      </div>
    </section>
  )
}
